import React from "react";
import { useTranslation } from "react-i18next";
import OrderItemRow from "./OrderItemRow";
import type { TransformedOrderItem } from "../types/orderApiTypes";

interface OrderItemsListProps {
  items: TransformedOrderItem[];
}

const OrderItemsList: React.FC<OrderItemsListProps> = ({ items }) => {
  const { t } = useTranslation();

  return (
    <div className="order-items-section">
      <h3>{t("order.itemsTitle", "Order Items")}</h3>
      <table className="order-items-table">
        <thead>
          <tr>
            <th className="item-thumbnail-header"></th>
            <th>{t("cart.item.product", "Product")}</th>
            <th className="item-quantity-header">
              {t("cart.item.quantity", "Quantity")}
            </th>
            <th className="item-total-header">
              {t("order.item.total", "Total")}
            </th>
          </tr>
        </thead>
        <tbody>
          {items.map((item) => (
            <OrderItemRow key={item.key} item={item} />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default OrderItemsList;
